import { useQuery } from '@tanstack/react-query'

import { getHeaderMenu } from 'api/Header/categories'

function useGetHeaderMenu() {
  return useQuery(['get-header-menu'], getHeaderMenu)
}

export default useGetHeaderMenu
